module.exports = __webpack_public_path__ + "img/ss-4def.fcad7e6e.svg";